//Game state

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Forest, Animal, DailyExercise } from '../../types';

interface GameState {
  currentForest: Forest | null;
  animals: Animal[];
  dailyExercises: DailyExercise[];
  currentDay: number;
  hasCompletedDailyExercise: boolean;
}

const initialState: GameState = {
  currentForest: null,
  animals: [],
  dailyExercises: [],
  currentDay: 1,
  hasCompletedDailyExercise: false,
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setCurrentForest: (state, action: PayloadAction<Forest | null>) => {
      state.currentForest = action.payload;
    },
    setAnimals: (state, action: PayloadAction<Animal[]>) => {
      state.animals = action.payload;
    },
    setDailyExercises: (state, action: PayloadAction<DailyExercise[]>) => {
      state.dailyExercises = action.payload;
    },
    setCurrentDay: (state, action: PayloadAction<number>) => {
      state.currentDay = action.payload;
    },
    setHasCompletedDailyExercise: (state, action: PayloadAction<boolean>) => {
      state.hasCompletedDailyExercise = action.payload;
    },
    incrementDay: (state) => {
      state.currentDay += 1;
      state.hasCompletedDailyExercise = false;
    },
    resetGame: (state) => {
      state.currentForest = null;
      state.currentDay = 1;
      state.hasCompletedDailyExercise = false;
    },
  },
});

export const {
  setCurrentForest,
  setAnimals,
  setDailyExercises,
  setCurrentDay,
  setHasCompletedDailyExercise,
  incrementDay,
  resetGame,
} = gameSlice.actions;

export default gameSlice.reducer;
